import { Config } from 'configs';
import { parseSafeJSON } from 'utils/jsonHelpers';
import createDataContext from './createDataContext';

const currentLanguageKey = '@Waitless-language';
const currentSelectedLanguagesKey = '@Waitless-languages';

// For translatable input
const reducer = (state, action) => {
  switch (action.type) {
    case 'setInitialized':
      return { ...state, initialized: true };
    case 'onChangeLanguage':
      return { ...state, currentLanguage: action.payload };
    case 'setSelectedLanguages':
      return { ...state, selectedLanguages: action.payload };
    default:
      return state;
  }
};

const init = (dispatch) => () => {
  const currentLanguage = global.localStorage.getItem(currentLanguageKey) || 'en';

  let selectedLanguages = parseSafeJSON(global.localStorage.getItem(currentSelectedLanguagesKey), true);

  if (!selectedLanguages) {
    selectedLanguages = [...Config.AVAILABLE_LANGUAGES];
  }

  dispatch({ type: 'setInitialized' });
  dispatch({ type: 'onChangeLanguage', payload: currentLanguage });
  dispatch({ type: 'setSelectedLanguages', payload: selectedLanguages });
};

const changeCurrentLanguage =
  (dispatch) =>
    async (newLang) => {
      global.localStorage.setItem(currentLanguageKey, newLang);

      dispatch({ type: 'onChangeLanguage', payload: newLang });
    };

const changeLanguageDisplay =
  (dispatch, state) =>
    async (lang, selected) => {
      let currentSelected = [...(state.selectedLanguages || [])];

      if (selected) {
        if (!currentSelected.includes(lang)) {
          currentSelected.push(lang);
        }
      } else {
        currentSelected = currentSelected.filter((x) => x !== lang);
      }

      // If current language is disabled
      if (!currentSelected.includes(state.currentLanguage)) {
        global.localStorage.setItem(currentLanguageKey, 'en');
        dispatch({ type: 'onChangeLanguage', payload: 'en' });
      }

      global.localStorage.setItem(currentSelectedLanguagesKey, JSON.stringify(currentSelected));

      dispatch({ type: 'setSelectedLanguages', payload: currentSelected });
    };

const initialData = {
  initialized: false,
  currentLanguage: 'en',
  selectedLanguages: [],
};

export const { Context, Provider } = createDataContext(
  reducer,
  { changeCurrentLanguage, changeLanguageDisplay },
  { ...initialData },
  null,
  init,
);
